/* 6FT Club product card: insole "Add to cart" button.
   Single-variant product -> window.SixFtCart.addVariant(id, 1) then open the drawer.
   Multi-variant product  -> opens quick view by clicking the card's own .qv-btn
   (theme.js owns quick view). Loaded once per page even if the tag repeats. */
(function () {
  if (window.SixFtProductCard) return;
  window.SixFtProductCard = { ready: true };

  var ADDING_LABEL = 'Adding…';
  var ERROR_LABEL = 'Could not add, try again';
  var ERROR_RESET_MS = 2400;

  function openQuickView(button) {
    var card = button.closest('[data-product-card]');
    var qv = card && card.querySelector('.qv-btn');
    if (qv) {
      qv.click();
      return;
    }
    if (button.dataset.productUrl) window.location.href = button.dataset.productUrl;
  }

  function addToCart(button) {
    var variantId = button.dataset.variantId;
    var cart = window.SixFtCart;
    if (!variantId) return;
    if (!cart || typeof cart.addVariant !== 'function') {
      // Cart API unavailable: fall back to the product page rather than failing silently.
      if (button.dataset.productUrl) window.location.href = button.dataset.productUrl;
      return;
    }
    var label = button.textContent;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = ADDING_LABEL;
    Promise.resolve(cart.addVariant(Number(variantId), 1))
      .then(function () {
        button.textContent = label;
        button.disabled = false;
        button.removeAttribute('aria-busy');
        if (typeof cart.open === 'function') cart.open();
      })
      .catch(function (err) {
        console.error('[6FT] product card add to cart failed', err);
        button.removeAttribute('aria-busy');
        button.disabled = false;
        button.textContent = ERROR_LABEL;
        setTimeout(function () { button.textContent = label; }, ERROR_RESET_MS);
      });
  }

  document.addEventListener('click', function (e) {
    var button = e.target.closest && e.target.closest('.pc__add');
    if (!button || button.disabled) return;
    e.preventDefault();
    if (button.hasAttribute('data-open-quick-view')) {
      openQuickView(button);
    } else {
      addToCart(button);
    }
  });
})();
